import { Designer, IAddProjectCoverContent, Project, Tag } from '@brg/api';
import { LongreadViewType } from "../../components/ViewTypeController/ViewTypeController";

export type AuthorT = Designer<'Local'> & { disabled?: boolean };

export interface ProjectEditPageProps {
  className?: any;
  isTransfer?: boolean;
  project?: Project<'Global'>;
}

export enum LongreadMobileActions {
  add = 'add',
  close = 'close',
  save = 'save',
  update = 'update',
  savePresentation = 'savePresentation',
  empty = ''
}

export enum AutoTranslateStatus {
  NotTranslated = 0,  // Процесс автоперевода не запущен
  InProcess = 1,      // В процессе автоперевода
  Complete = 2,       // Автоперевод завершен
  Stopped = 3         // Автоперевод отменен/не завершен
}

export enum AvailabilityAction {
  open = 'open',
  link = 'link',
}

export type PostWithIdT = {
  name: string,
  id: string,
  count: number
}

export interface ProjectFormObject extends Project<'Global'> {
  places: Tag[];
  cities: Tag[];
  requiredTags: Tag[];
  proTags?: any[];
  availability?: AvailabilityAction;
  viewType?: LongreadViewType;
  regNumber?: string;
  color?: string;
  additionalInfo?: any;
  updateTrigger?: number | undefined;
  hasTitleImage?: boolean;
  hasTitleImageEn?: boolean;
  includesLongreadPosts: PostWithIdT[]
}import { Designer, IAddProjectCoverContent, Project, Tag } from '@brg/api';
import { LongreadViewType } from "../../components/ViewTypeController/ViewTypeController";

export type AuthorT = Designer<'Local'> & { disabled?: boolean };

export interface ProjectEditPageProps {
  className?: any;
  isTransfer?: boolean;
  project?: Project<'Global'>;
}

export enum LongreadMobileActions {
  add = 'add',
  close = 'close',
  save = 'save',
  update = 'update',
  savePresentation = 'savePresentation',
  empty = ''
}

export enum AutoTranslateStatus {
  NotTranslated = 0,  // Процесс автоперевода не запущен
  InProcess = 1,      // В процессе автоперевода
  Complete = 2,       // Автоперевод завершен
  Stopped = 3         // Автоперевод отменен/не завершен
}

export enum AvailabilityAction {
  open = 'open',
  link = 'link',
}

export type PostWithIdT = {
  name: string,
  id: string,
  count: number
}

export interface ProjectFormObject extends Project<'Global'> {
  places: Tag[];
  cities: Tag[];
  requiredTags: Tag[];
  proTags?: any[];
  availability?: AvailabilityAction;
  viewType?: LongreadViewType;
  regNumber?: string;
  color?: string;
  additionalInfo?: any;
  updateTrigger?: number | undefined;
  hasTitleImage?: boolean;
  hasTitleImageEn?: boolean;
  includesLongreadPosts: PostWithIdT[]
}